module.exports = __webpack_public_path__ + "img/sponsorC09.aa3a4760.png";